import { Injectable } from "@angular/core";
import { MdDialogRef, MdDialog } from "@angular/material";
import { ScegliZonaUVDialog } from "./ScegliZonaUV.component";
import { AuthService } from "../../services/auth.service";

@Injectable()
export class LeftMenuService {
  constructor(
    private authService: AuthService,
    private cambiaZonaUVDialog: MdDialog
  ) {}
  cambiaUVZONA() {
    this.authService.logoutIfSessionExpired().subscribe();
    let scegliZonaUV: MdDialogRef<ScegliZonaUVDialog> = this.cambiaZonaUVDialog.open(
      ScegliZonaUVDialog,
      { data: { utenteRef: this.authService.user } }
    );
    scegliZonaUV.disableClose = true;
    let shallReOpen = false;
    scegliZonaUV.beforeClose().subscribe((data) => {
      if (!scegliZonaUV.componentInstance.toClose) {
        shallReOpen = true;
      } else {
        shallReOpen = false;
      }
    });
    scegliZonaUV.afterClosed().subscribe((data) => {
      if (shallReOpen) {
        scegliZonaUV = this.cambiaZonaUVDialog.open(ScegliZonaUVDialog, {
          data: { utenteRef: this.authService.user },
        });
      }
    });

    // this.userService.RefreshSIUTokenRequest(this._user.token).subscribe(
    //   data => {
    //     if (data.isSIUTokenRenewed === true) {
    //       if (!menuItem.isChangeUVCommand) {

    //         let scope = this;
    //         let url = menuItem.routeROL + '?GUID=' + data.siuToken;
    //         let urlTo = Configurations.rolWebBaseUrl + "RolWebLink.html?GUID=" + data.siuToken;
    //         for (let par in menuItem.parameters) {
    //           url = url + "&" + par + "=" + menuItem.parameters[par];
    //         }
    //         urlTo += "&url=" + encodeURIComponent(url);
    //         win.location.href = urlTo;
    //       } else {
    //         scegliZonaUV.componentInstance.start();
    //       }
    //     } else {
    //       if (scegliZonaUV != null) {
    //         scegliZonaUV.close();
    //       }
    //       this.showError(data.message);
    //     }
    //   });
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/layout/left-menu.service.ts